module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.$t('title.edit-mobile')))]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.details')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('data-form', {
    attrs: {
      "model": "mobiles",
      "entity": _vm.mobile,
      "fields": _vm.fields
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.notifications')
    }
  }, [_c('notification-settings', {
    attrs: {
      "mobile": _vm.mobile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-118a8080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileDetails.vue
// module id = 1123
// module chunks = 2